import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NavController } from '@ionic/angular';
import { AuthService } from '../services/auth/auth.service';
import { MixpanelAnalyticsService } from '../services/mixpanel-analytics/mixpanel-analytics.service';
import { OnboardingService } from '../services/onboarding/onboarding.service';
import { ProfileService } from '../services/profile/profile.service';

@Injectable({ providedIn: 'root' })
export class InitialNavGuard implements CanActivate {
  private router = inject(Router);
  private authService = inject(AuthService);
  private navController = inject(NavController);
  private mixpanel = inject(MixpanelAnalyticsService);
  private profile = inject(ProfileService);
  private onboardingService = inject(OnboardingService);

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    if (await this.authService.isLoggedin()) {
      await this.profile.getProfile();
      this.mixpanel.login(this.profile.getNonSensitiveProfile());
      this.navController.setDirection('root');
      const nextRoute = this.onboardingService.getNextRoute() || 'tabs';
      return this.router.parseUrl(nextRoute);
    }

    const loginMethod = route.queryParamMap.get('loginmethod');
    const throughOption = route.queryParamMap.get('throughOption') ?? loginMethod;
    if (throughOption) {
      return this.router.createUrlTree(['signin'], {
        queryParams: {
          throughOption,
        },
      });
    }
    return this.router.createUrlTree(['landing']);
  }
}
